import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ImpactedAssetDto, LandTitleDto, TitleDto, BankDto, AddressBookDto, ImpactedCommunityDto, CommunityDto, LgaDto, StateDto, PartyDto, TerrainDto, AreaOfImpactDto, IncidentCategoryDto, IncidentSubCategoryDto, IncidentDto, IncidentQuantumOfImpactDto, FacilityAssetDto, CleanUpStatusDto, UomDto, OwnershipTypeDto, AreaMapOfSpillDto, AppConfigurationDto, SecurityClassificationDto, DocumentTypeCodeDto, DocumentTypeDto, FiscalFileLocationDto, LandTitleRegisterDto } from '@cradua/data';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import Swal from "sweetalert2";
import * as randomize from "randomatic";
import { AddressBookComponent } from './address-book/address-book.component';

@Component({
  selector: 'cradua-incident',
  templateUrl: './incident.component.html',
  styleUrls: ['./incident.component.scss']
})
export class IncidentComponent implements OnInit {

  @Input() incident: IncidentDto[];
  @Input() incidentcategorys: IncidentCategoryDto[];
  @Input() incidentsubcategorys: IncidentSubCategoryDto[];
  @Input() quantums: IncidentQuantumOfImpactDto[];
  @Input() facilityassets: FacilityAssetDto[];
  @Input() cleanupstatuss: CleanUpStatusDto[];
  @Input() uoms: UomDto[];
  @Input() partys: PartyDto[];
  @Input() terrains: TerrainDto[];
  @Input() appConfig: AppConfigurationDto[];
  @Input() areaofimpacts:AreaOfImpactDto[];
  @Input() impactedcommunitys: ImpactedCommunityDto[];
  @Input() impactedassets: ImpactedAssetDto[];
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() communities:CommunityDto[];
  @Input() addressBooks: AddressBookDto[];
  @Input() isLoadingAddressBook: boolean;
  @Input() banks: BankDto[];
  @Input() titles: TitleDto[];
  @Input() landTitles: LandTitleDto[];
  selectedIncident: IncidentDto;
  PaymentType = 'Incident';
  incidentType = '';

  @Input() securityClassifications: SecurityClassificationDto[];
  @Input() documentTypeCodes: DocumentTypeCodeDto[];
  @Input() documentTypes: DocumentTypeDto[];
  @Input() fileLocations: FiscalFileLocationDto[];
  @Input() fetchDocuments: LandTitleRegisterDto[];

  @Input() isLoadingDocument: boolean;

  @Input() completed: boolean;
  @Input() progress: number;
  @Input() error: string;
  @Input() isInProgress: boolean;
  @Input() isReady: boolean;
  @Input() hasFailed: boolean;

  @Output() emitUpload = new EventEmitter<any>();
  @Output() emitSaveManyDoc = new EventEmitter<any>();
  @Output() emitReset = new EventEmitter<any>();
  @Output() emitCancel = new EventEmitter<any>();

  @Output() emitIncident = new EventEmitter<IncidentDto>();
  @Output() emitareaofimpact = new EventEmitter<AreaOfImpactDto>();
  @Output() deleteAreaofImpactEvent = new EventEmitter<any>();
  @Output() emitimpactedcommunity = new EventEmitter<ImpactedCommunityDto>();
  @Output() emitAddressBook = new EventEmitter<any>();
  @Output() emitSaveAddressBook = new EventEmitter<any>();
  @Output() emitSaveAddressBookLessor = new EventEmitter<any>();
  @Output() emitFindAddressBookById = new EventEmitter<any>();
  @Output() emitUpdateAddressLessorInfo = new EventEmitter<any>();
  @Output() emitClearAddressBook = new EventEmitter<any>();
  @ViewChild(AddressBookComponent) addressBookComponentChild: AddressBookComponent;
  @Output() deletelessorevent = new EventEmitter();
  @Output() emitAssetSave = new EventEmitter<ImpactedAssetDto[]>();
  @Output() emitAssetDelete = new EventEmitter<any>();
  @Input() ownershiptypes: OwnershipTypeDto[];
  uomtab: UomDto[];
  incidentForm: FormGroup;
  incidentFormArray: FormGroup;
  selectedIncidentId: IncidentDto;
  filterIncidentSubCategory: IncidentSubCategoryDto[];
  showTab = false;
  filteredDelete: Array<any> =[];
  panelOpenState = false;
  selectedTabIndex = 0;
  isExpanded = true;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {

    this.uomtab = this.uoms;

    this.createIncidentForm();
    if(this.incident && this.incident.length) {
      this.selectedIncidentId = this.incident[0];
      this.onViewOrEdit(this.incident[0]);
    } else {
      this.selectedIncidentId = null;
    }

  }


  onViewOrEdit(selectedValue: IncidentDto) {
    this.incidentType = selectedValue.IncidentTypeStatus;
// console.log("incident quantum", selectedValue);
    this.showTab = true;
    if(selectedValue) {
      this.onFilterIncidentSubCategory(selectedValue.IncidentCategoryId);
      this.incidentForm.patchValue({
      IncidentNotificationId:selectedValue.IncidentNotificationId,
      IncidentName:selectedValue.IncidentName,
      IncidentCategoryId:selectedValue.IncidentCategoryId,
      FacilityAssetId:selectedValue.FacilityAssetId,
      LocationOfIncident:selectedValue.LocationOfIncident,
      CauseOfIncident:selectedValue.CauseOfIncident,
      TotalAreaOfImpact:selectedValue.TotalAreaOfImpact,
      UomId: selectedValue.UomId,
      NatureOfPolution:selectedValue.NatureOfPolution,
      IncidentQuantumId:selectedValue.IncidentQuantumId,
      QtySpilled: selectedValue.QtySpilled,
      QtyUOM:selectedValue.QtyUOM,
      IncidentDate: this.dateTransformation(selectedValue.IncidentDate),
      JIVDate: this.dateTransformation(selectedValue.JIVDate),
      JIVSurveyDate: this.dateTransformation(selectedValue.JIVSurveyDate),
      ReportedDate:this.dateTransformation(selectedValue.ReportedDate),
      Easting: selectedValue.Easting,
      Northing: selectedValue.Northing,
      QtyVolRecovered: selectedValue.QtyVolRecovered,
      CleanUpStatusId: selectedValue.CleanUpStatusId,
      QtyRecoveredUOM: selectedValue.QtyRecoveredUOM,
      IncidentTypeStatus: selectedValue.IncidentTypeStatus,
      IncidentEntryStatus: selectedValue.IncidentEntryStatus,
      IncidentSubCategoryId: selectedValue.IncidentSubCategoryId,
      Remarks: selectedValue.Remarks,
      id: selectedValue.id,
    });


    }
  }

  onUploadFile(value) {
    this.emitUpload.emit(value);
  }

  onSaveManyDoc(value: LandTitleRegisterDto[]) {
    this.emitSaveManyDoc.emit(value);
  }

  onCancelUpload(value) {
    this.emitCancel.emit('');
  }

  onResetUpload(value) {
    this.emitReset.emit('');
  }



  protected filterById = <T>(id: string, lookupId: string) =>
    (fieldName: T) => fieldName[lookupId] === id;

  onFilterIncidentSubCategory(id: string) {
    this.filterIncidentSubCategory = this.incidentsubcategorys.filter(
    this.filterById<IncidentSubCategoryDto>(id, "IncidentCategoryId"),

    );
  }


  createIncidentForm(){
    this.showTab = false;

    this.incidentForm = this.fb.group({
      IncidentNotificationId: ['', Validators.required],
      IncidentName: ['', Validators.required],
      IncidentDate: null,
      JIVDate: null,
      IncidentCategoryId: [''],
      FacilityAssetId: [''],
      LocationOfIncident: [''],
      CauseOfIncident: [''],
      TotalAreaOfImpact: [''],
      UomId: [''],
      NatureOfPolution: [''],
      IncidentQuantumId: [''],
      QtySpilled: [''],
      QtyUOM: [''],
      QtyRecoveredUOM:[''],
      ReportedDate: undefined,
      JIVSurveyDate: null,
      Easting: [''],
      Northing: [''],
      Remarks: [''],
      QtyVolRecovered:[0],
      CleanUpStatusId:[''],
      ArchiveStatus: [''],
      IncidentSubCategoryId: [''],
      IncidentTypeStatus:[''],
      IncidentEntryStatus: [''],
      id: null
    });

  }

  // public errorHandling = (control: string, error: string) => {
  //   return this.incidentForm.controls[control].hasError(error);
  // };

  onSubmit(formValue: IncidentDto) {

    if(this.incidentForm.invalid) {
      Swal.fire(
        "Warning!",
        "Fill the required fields",
        "warning",
      );
      return;
    }
    if(!formValue?.ReportedDate) {
      formValue.ReportedDate = null;
    }
    if(!formValue?.JIVSurveyDate) {
      formValue.JIVSurveyDate = null;
    }
    if(!formValue?.JIVDate) {
      formValue.JIVDate = null;
    }
    if(!formValue?.IncidentDate) {
      formValue.IncidentDate = null;
    }
    this.emitIncident.emit(formValue);
    // this.incidentForm.reset();
    this.showTab = true;
  }



onSubmitAreaOfImpact(formValue: AreaOfImpactDto[]){
  const newIncidentNotificationNo = Object.assign({}, this.selectedIncidentId);
 newIncidentNotificationNo.areaofimpacts = formValue;
 this.emitIncident.emit(newIncidentNotificationNo);
  // if(this.filteredDelete.length !== 0) {
  //   this.deleteAreaofImpactEvent.emit(this.filteredDelete);
  // }
}


onSubmitAreaOfSpill(formValue: AreaMapOfSpillDto[]){
  const newIncidentNotificationNo = Object.assign({}, this.selectedIncidentId);
 newIncidentNotificationNo.areaofspills = formValue;
 this.emitIncident.emit(newIncidentNotificationNo);
}


onSubmitImpactedCommunity(formValue: ImpactedCommunityDto[]){

  const newIncidentNotificationNo = Object.assign({}, this.selectedIncidentId);
 newIncidentNotificationNo.impactedcommunitys = formValue;
 this.emitIncident.emit(newIncidentNotificationNo);

}
 dateTransformation(date) {
    if(!date) return null;
    let d = new Date(date);
    let day = '' + d.getDate();
    let month = '' + (d.getMonth() + 1);
    let year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  onChangeNotificationNoGenerator(event: string) {
    if(event === 'Automatic') {

      const generatedCode = `INCIDENT${randomize("0", 6)}`
      this.incidentForm.patchValue({IncidentNotificationId: generatedCode});
      this.incidentForm.controls['IncidentNotificationId'].disable()
    } else {
      if(this.incidentForm.controls['IncidentNotificationId'].status === 'DISABLED') {
        this.incidentForm.controls['IncidentNotificationId'].enable();
        this.incidentForm.patchValue({IncidentNotificationId: ''});
      }
    }
  }

///Address Book Functions start here////
onEmitCreateAddressBook(value) {
  this.selectedTabIndex = value.selectedIndex;
  this.isExpanded = false;
  this.addressBookComponentChild.task = 'create';

}

onSearchAddressBook(query) {
  this.emitAddressBook.emit(query);
}

onSaveAddressBook(value: AddressBookDto) {
  this.emitSaveAddressBook.emit(value);
  const addressBook = Object.assign({}, value);
  if(addressBook.id != null) {
    addressBook['IncidentSerialId'] = this.selectedIncidentId.id;
    addressBook['BankId'] = this.getBankName(addressBook.BankId);
    this.emitUpdateAddressLessorInfo.emit(addressBook)
  }
}

onEmitClearAddressBook(value) {
  this.emitClearAddressBook.emit(value);
}


getBankName(id: string) {
  const found = this.banks.find(bank => bank.id === id);
  return found ? found.BankName : null;
 }

 onEmitAssetSubmit(formValue:ImpactedAssetDto[]) {
  const newIncidentNotificationNo = Object.assign({}, this.selectedIncidentId);

  if(newIncidentNotificationNo.id != null){
  newIncidentNotificationNo.impactedassets = formValue;
  this.emitIncident.emit(newIncidentNotificationNo);

  if(this.filteredDelete.length !== 0) {
    this.emitAssetDelete.emit(this.filteredDelete);
  }

  }


}



onEmitAssetDelete(valueIndex) {
  this.emitAssetDelete.emit(valueIndex);
}


tabChanged(tabChangeEvent): void {
  this.isExpanded = false;
}

public errorHandling = (control: string, error: string, type?: string) => {
  const formControl = this.incidentForm.controls[control];
  return formControl.hasError(error);
}

}
